import Base from "./base.service.js";
export default class Model extends Base {
    constructor() {
        super("model");
    }
}
